<template>
  <footer
    class="grid grid-cols-1-auto p-3 text-gray-400 text-xs font-light tracking-wider border-t border-gray-200"
  >
    <div>
      <span class="font-normal">STUPSI</span>
      Admin Interface © {{getYear()}}
    </div>
    <div>
      <span class="text-gray-300 tracking-widest hover:text-inherit transition-colors duration-200">
        <a href="https://donau-uni.ac.at/ags">Made with ♫ by DUK</a>
      </span>
    </div>
  </footer>
</template>

<script>
import DateMixin from "@/mixins/DateMixin";
export default {
  name: "WdFooter",
  mixins: [DateMixin],
  data() {
    return {};
  },
  props: {},
  components: {},
  methods: {},
  computed: {},
  created() {}
};
</script>
